<template>
  <div class="top-nav">
    <a @click="toggle"><i class="iconfont icon-bars"></i></a>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        {{ user.group_print_name }}&nbsp;{{ user.realname }}&nbsp;<span v-if="expiry" style="color:red">{{ expiry }}</span><i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="change" v-if="user.role_id === 1 || user.allow_group_ids.length > 1">切换考场</el-dropdown-item>
        <el-dropdown-item command="charge" v-if="[4,8,9,15,17,19].indexOf(user.group_id) >= 0">账号续期</el-dropdown-item>
        <el-dropdown-item command="password">修改密码</el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="切换考场" :visible.sync="changeFormVisible">
      <div style="text-align:center;">
        <el-select
          v-model="groupId"
          placeholder="选择考场"
          @change="changeGroup()">
          <el-option
            v-for="item in groupList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="passwordFormVisible">
      <el-form :model="passwordForm" ref="passwordForm" :rules="passwordFormRules" label-width="200px">
        <el-form-item label="当前密码" prop="oldpass">
          <el-input type="password" v-model="passwordForm.oldpass" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpass">
          <el-input type="password" v-model="passwordForm.newpass" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码" prop="newpass2">
          <el-input type="password" v-model="passwordForm.newpass2" style="width:194px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passwordFormCommit" :loading="passwordFormCommiting">确 定</el-button>
        <el-button @click="passwordFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="账号续期" :visible.sync="payVisible" class="pay-dialog">
      <div>
        <div>您的账号{{ expiryDay >= 0 ? '将' : '已' }}于<strong style="color:red">{{ user.expiry_date }}</strong>到期,请微信扫码支付</div>
        <div v-if="expiryDay < 0"><span style="color:red">***</span>如果支付后还出现这个提示,请重新登录</div>
        <img alt="微信支付" :src="`https://oss.jiaxiao.fun/wxpay.png`" style="width:430px;height:430px;"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    user: Object
  },
  data () {
    return {
      passwordFormVisible: false,
      passwordForm: {
        oldpass: '',
        newpass: '',
        newpass2: ''
      },
      passwordFormRules: {
        oldpass: [
          { required: true, message: "请输入当前密码", trigger: "blur" }
        ],
        newpass: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入新密码'));
              } else {
                if (this.passwordForm.newpass2 !== '') {
                  this.$refs.passwordForm.validateField('newpass2')
                }
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        newpass2: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入新密码'))
              } else if (value !== this.passwordForm.newpass) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      passwordFormCommiting: false,
      changeFormVisible: false,
      groupList: [],
      groupId: this.user.group_id,
      payVisible: false
    }
  },
  computed: {
    expiryDay () {
      if (!this.user.expiry_date) {
        return 365
      }
      return parseInt((new Date(this.user.expiry_date).getTime() - Date.now())/1000/3600/24)
    },
    expiry () {
      if (this.expiryDay < 10) {
        if (this.expiryDay < 0) {
          return '账号已过期'
        } else if (this.expiryDay === 0) {
          return '账号今天到期'
        } else {
          return '账号' + this.expiryDay + '天后到期'
        }
      }
      return ''
    }
  },
  mounted () {
    this.fetchGroupList()
    setInterval(() => {
      if (this.expiryDay < 0) {
        this.payVisible = true
      }
    }, 120 * 1000) // 每分钟提醒一次
  },
  methods: {
    toggle () {
      this.$emit('toggle')
    },
    handleCommand (command) {
      if (command === 'change') {
        this.changeFormVisible = true
      } else if (command === 'password') {
        this.passwordFormVisible = true
      } else if (command === 'logout') {
        this.$http.post('/auth/logout').then(response => {
          localStorage.removeItem('kaochang.token')
          localStorage.removeItem('kaochang.password')
          localStorage.removeItem('kaochang.remember')
          this.$router.replace('/login')
        })
      } else if (command === 'charge') {
        this.payVisible = true
      }
    },
    fetchGroupList () {
      this.$http.get('/dbapi/group_list').then(response => {
        if (response.data.success) {
          this.groupList = response.data.list
        }
      })
    },
    changeGroup () {
      this.$http.post('/auth/change_group', {
        group_id: this.groupId
      }).then(response => {
        if (response.data.success) {
          location.reload()
        }
      })
    },
    passwordFormCommit: _.throttle(
      function () {
        this.$refs.passwordForm.validate(valid => {
          if (valid) {
            this.passwordFormCommiting = true
            this.$http.post('/auth/change_password', this.passwordForm).then(response => {
              this.passwordFormCommiting = false
              if (response.data.success) {
                this.$refs.passwordForm.resetFields()
                this.passwordFormVisible = false
                this.$message({
                  type: 'success',
                  message: '密码修改成功'
                })
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      2000
    )
  }
}
</script>

<style>
.top-nav {
  display: flex;
  justify-content: space-between;
}
.top-nav a {
  color: #5A738E;
  cursor: pointer;
}
.top-nav .iconfont {
  font-size: 24px;
}
.top-nav .pay-dialog .el-dialog {
  width: 740px;
}
.top-nav .pay-dialog .el-dialog .el-dialog__body {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue